import Translate from '../../i18n/Translate'
import { useTranslation } from 'react-i18next'

const DayDetail = ({ day, title, description, image }) => {
    const { t } = useTranslation()

    return (
        <li className="day-detail">
            {day && day.length ? (
                <h3 className="day">
                    <Translate langkey="commons.day" />
                    {day.length === 2
                        ? day.map((d, i) => {
                              //Le agrego ' Y ' al primero
                              return (
                                  <span key={i}>
                                      {' '}
                                      {d} {i === 0 ? `${t('commons.and')}` : ''}
                                  </span>
                              )
                          })
                        : day.map((d, i) => {
                              //Agrego ', ' a todos, ' Y ' al anteultimo, y nada al ultimo
                              return (
                                  <span key={i}>
                                      {' '}
                                      {d}
                                      {i === day.length - 2 && `${t('commons.and')}`}
                                      {i !== day.length - 2 && i !== day.length - 1 && ', '}
                                  </span>
                              )
                          })}
                </h3>
            ) : (
                <h3 className="day">
                    <Translate langkey="commons.day" />
                    <span> {day}</span>
                </h3>
            )}
            {title && <h4 className="title">{title}</h4>}

            {description && <div className="description" dangerouslySetInnerHTML={{ __html: description }} />}
            {/* {description && <p className="description">{description}</p>} */}

            {/* Si solo hay una imagen renderizamos una etiqueta img simple */}
            {image && image.length === 1 && <img src={image.thumbnail[0]} alt={title && title} className="day-image" />}
            {/* Si hay mas de una imagen renderizamos una etiqueta img con un srcSet */}
            {image && image.length > 1 && (
                <img
                    src={image[0]}
                    srcSet={`${image[0]} 1x, ${image[1]} 2x, ${image[1]} 3x`}
                    alt={title && title}
                    className="day-image"
                />
            )}
        </li>
    )
}

export default DayDetail
